import { cva, VariantProps } from "class-variance-authority";
import { HTMLAttributes } from "react";

const dotClassNames = cva("tw-inline-block tw-rounded-full", {
    variants: {
        size: {
            sm: "tw-h-1 tw-w-1",
            md: "tw-h-2 tw-w-2",
            lg: "tw-h-3 tw-w-3",
            xl: "tw-h-4 tw-w-4",
        },
        color: {
            primary: "tw-bg-primary",
            secondary: "tw-bg-secondary",
            success: "tw-bg-success",
            warning: "tw-bg-warning",
            danger: "tw-bg-danger",
        },
    },
    defaultVariants: {
        size: "md",
        color: "primary",
    },
});

const Dot = ({
    className,
    size,
    color,
    ...props
}: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof dotClassNames>) => {
    return <span className={dotClassNames({ className, size, color })} {...props} />;
};

export default Dot;
